var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineUpYellowRedCardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "line-up-player-action-icon-border-stroke",
    x: -0.987341,
    y: -0.99992,
    width: 8,
    height: 11,
    rx: 3,
    transform: "matrix(1 0 -0.0126592 0.99992 2.10111 1.99992)",
    fill: "#F20D0D",
    stroke: "#14171F",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1747_278239",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 7,
    height: 9
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 9,
    rx: 2,
    transform: "matrix(1 0 -0.0126592 0.99992 2.11377 2)",
    fill: "#FFBF00"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1747_278239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.11377 2L4.11377 2C3.0092 2 2.10243 2.89536 2.08845 3.99984L1.99984 10.9993L8.11377 2Z",
    fill: "#FFBF00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineUpYellowRedCardIcon);
export default __webpack_public_path__ + "static/media/line_up_yellow_red_card_icon.2e8155d4bfe153b393a87db9c9ca71e8.svg";
export { ForwardRef as ReactComponent };